const ENV = "dev";
export const RAZORPAY_KEY = "rzp_test_PrYFlV8L1wbhre";

export default ENV;
